import { edition as edition0 } from './editions/2026-08/edition'

export const OBSERVATORY_EDITIONS = [edition0]
